/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamskillgroups2Inputs */

const en_entity_teamskillgroups2 = /** @type {(inputs: Entity_Teamskillgroups2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Skill Groups`)
};

const de_entity_teamskillgroups2 = /** @type {(inputs: Entity_Teamskillgroups2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skillgruppen`)
};

/**
* | output |
* | --- |
* | "Team Skill Groups" |
*
* @param {Entity_Teamskillgroups2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamskillgroups2 = /** @type {((inputs?: Entity_Teamskillgroups2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamskillgroups2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamskillgroups2(inputs)
	return de_entity_teamskillgroups2(inputs)
});
export { entity_teamskillgroups2 as "entity_teamSkillGroups" }